<template>
  <div id="app" class="layout">
    <Modal
      :value="is_show_browser"
      :title="$t('app.broswer')"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
      <p>
        <!-- 浏览器不符合的弹窗 -->
        {{ "app.broswer0" | t }}
        <a
          v-if="OS_name == 'mac'"
          href="http://download.nikemoment.com/googlechrome.dmg"
          target="_blank"
          >{{ "app.broswer1" | t }}</a
        >
        <a
          v-if="OS_name == 'windows'"
          href="http://download.nikemoment.com/ChromeStandaloneSetup64.exe"
          target="_blank"
          >{{ "app.broswer1" | t }}</a
        >
      </p>
      <p v-if="OS_name != 'mac' && OS_name != 'windows'">
        {{ "app.broswer1" | t }}
      </p>
    </Modal>
    <Layout
      :class="!is_show_header ? 'login_bg' : 'no_bg'"
      :style="{ height: '100%' }"
    >
      <Header v-if="is_show_header">
        <h2
          :class="
            !is_ipad
              ? 'iconfont icon-emoment'
              : 'iconfont icon-emoment icon_center'
          "
        ></h2>
        <div>
          <div
            class="item user"
            @click="show_me_drawer = !show_me_drawer"
            id="personal"
            v-if="!is_ipad"
          >
            <img :src="user_avatar" />
            <h5 class="down">{{ user_name }}</h5>
          </div>

          <div
            v-show="is_ipad"
            :class="is_ipad ? 'item language icon_right' : 'item language'"
          >
            <img src="/static/images/icon_language.svg" />
            <Dropdown
              id="swtich_lang_dropdown"
              v-on:on-click="switchLang"
              trigger="click"
            >
              <a href="javascript:void(0)">
                {{ current_lang }}
              </a>
              <DropdownMenu slot="list">
                <DropdownItem
                  :name="index"
                  :key="index"
                  v-for="(item, index) in lang_list"
                  :id="'swtich_lang_dropdown_' + index"
                  >{{ item }}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>

          <div
            class="item home"
            v-if="is_admin && !is_ipad"
            @click="gotoAdminPortal"
            id="system"
          >
            <img src="/static/images/system_admin.svg" />
            <h5>{{ "system_admin" | t }}</h5>
          </div>

          <div
            class="item home"
            :style="is_ipad ? 'position:absolute;right:100px;' : ''"
            v-if="is_show_home_button"
            @click="gotoEventList"
          >
            <img src="/static/images/icon_home.svg" />
            <h5>{{ "session.home" | t }}</h5>
          </div>
          <div class="item notice" v-if="!is_ipad" @click="showNotice">
            <Badge :count="$store.getters.get_unread_by_total" :offset="[8, 7]">
              <img src="../static/images/icon_通知公告管理.svg" alt="" />
              <h5>{{ $t("notice") }}</h5>
            </Badge>
          </div>
          <div
            class="item home"
            v-if="$store.state.channel_list.length > 0"
            @click="$router.push({ name: 'ChannelList' })"
            id="broadcaster"
          >
            <img src="/static/images/broadcaster.svg" />
            <h5>{{ $t("litter_helper.broadcaster") }}</h5>
          </div>
          <div
            class="item user_identify"
            v-if="
              !is_ipad &&
                is_show_home_button &&
                current_stage != 10 &&
                user_identify_list &&
                user_identify_list.length > 1
            "
          >
            <Dropdown
              trigger="click"
              style="height: 50px;position: relative;top:20px"
              v-on:on-click="changeIdentify"
            >
              <div
                style="color: white;height: 40px;position: relative;top:-20px"
              >
                <img
                  width="26px"
                  height="26px"
                  src="/static/images/icon_participant.svg"
                />
                <h5>
                  {{ $t(identify_text(current_user_identify)) }}
                  <Icon type="ios-arrow-down"></Icon>
                </h5>
              </div>
              <DropdownMenu slot="list">
                <DropdownItem
                  v-for="(iden, index) in user_identify_list || []"
                  :name="iden"
                  :key="index"
                  @click="changeIdentify(iden)"
                  >{{ $t(identify_text(iden)) }}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div
            class="item"
            v-if="!is_ipad && is_show_home_button && has_mdtf"
            @click="gotoMDTF"
          >
            <template v-if="$i18n.locale != 'en'">
              <img
                style="height: 32px;width: 32px;margin-bottom: 4px"
                src="/static/images/mdtf/GOPAL.svg"
              />
              <h5 style="letter-spacing: 1px">{{ $t("PAL") }}</h5>
            </template>
            <h5 class="pal_enter" v-else>{{ $t("PAL") }}</h5>
            <!-- <h5 style="letter-spacing: 1px">PAL</h5> -->
          </div>
        </div>
      </Header>
      <router-view />
      <Footer
        v-if="is_show_header"
        class="footer_meetingzen"
        :class="{ session_footer: is_session_footer }"
      >
        <a href="/Privacy">{{ "privacy" | t }}</a>
        POWERED BY NIKE
      </Footer>
      <van-tabbar
        style="z-index: 1000"
        active-color="orange"
        v-if="is_mobile && isMobilePath"
        v-model="mobile_menu"
        @change="mobileGoTo(mobile_menu)"
      >
        <van-tabbar-item name="/mobile/mobileEventList" icon="todo-list-o">
          {{ $t("mobile.event_list") }}
        </van-tabbar-item>
        <van-tabbar-item name="/mobile/passCard" icon="qr"
          >{{ $t("mobile.pass_card") }}
        </van-tabbar-item>
        <!--        <van-tabbar-item name="/mobile/me" icon="contact">{{$t("mobile.my_home")}}</van-tabbar-item>-->
        <van-tabbar-item name="/mobile/mySport" icon="contact">
          <template #icon="props">
            <div style="font-size: 12px;padding-top: 5px">
              <div style="margin-bottom: 4px">
                <Icon size="22" type="ios-walk" />
              </div>
              <div>{{ $t("mobile.my_sport") }}</div>
            </div>
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </Layout>
    <!-- 个人中心 -->
    <Drawer
      title=""
      :closable="false"
      v-model="show_me_drawer"
      :mask="false"
      class-name="me_style"
      width="280"
    >
      <div class="avatar_c">
        <div style="display: flex;align-items: center;justify-content: center">
          <div
            class="img"
            :style="{
              backgroundImage: 'url(' + user_avatar + ')',
              marginLeft: '7.5px'
            }"
          ></div>
          <!--            -->
          <!--          <div style="margin-top: 30px;margin-left: 45px;position: relative">-->
          <!--            <img @click="showScoreDetail" src="/static/images/icon/score.svg" style="position: relative;top: 3px;cursor: pointer" height="16px" >-->
          <!--            <span @click="showScoreDetail" style="cursor: pointer">{{$t('score.score')}}: {{score}}</span>-->
          <!--            <Icon @click="showScoreRule = !showScoreRule" size="8px" class="question_icon" type="md-help"  />-->
          <!--            <div v-if="showScoreRule" class="scoreRule">-->
          <!--              <icon class="close_icon" type="md-close" @click="showScoreRule = !showScoreRule;show_score_detail =false " style="right: 10px;top: 10px;"></icon>-->
          <!--              <score-rule ></score-rule>-->
          <!--            </div>-->
          <!--            <div v-if="show_score_detail" class="scoreDetail">-->
          <!--              <icon class="close_icon" type="md-close" @click="show_score_detail = !show_score_detail;showScoreRule = false" style="right: 10px;top: 10px;"></icon>-->
          <!--              <score-detail ></score-detail>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div style="display: flex;align-items: center;justify-content: center">
          <upload-file
            class="upload_avatar"
            ref="upload_avatar"
            :change-action="uploadAvatar"
            button-name="register.upload_avatar"
            button-id="upload_avatar"
            accept-type=".png,.jpg,.jpeg"
            button-icon=""
            button-size="small"
            style="width: 71px"
          ></upload-file>
          <!--          <div class="sign_up" style="width:auto;margin-left: 20px">-->
          <!--            <Button v-if="!isSign" @click="signIn" style="width: 150px;color: #ffffff;font-weight: 600">-->
          <!--              <img height="16px" src="/static/images/signed.svg" style="position: relative;top:2px;margin-right: 5px;">-->
          <!--             {{$t('score.sign_in')}}-->
          <!--            </Button>-->
          <!--            <Button v-else disabled style="width: 120px;color: #ffffff;font-weight: 600;background-color: #4c4c4c;border-color: #4c4c4c">-->
          <!--              <img height="16px" src="/static/images/sign.svg" style="position: relative;top:2px;margin-right: 5px;">-->
          <!--              {{$t('score.signed')}}-->
          <!--            </Button>-->
          <!--          </div>-->
        </div>
      </div>

      <Form>
        <FormItem :label="$t('register.name')">
          <Input
            type="text"
            maxlength="20"
            :show-word-limit="true"
            v-model="user_info_detail.name"
          >
          </Input>
        </FormItem>
        <FormItem :label="$t('register.phone')">
          <div class="phone_c">
            <select v-model="user_info_detail.login_phone_prefix" disabled>
              <option
                v-for="(item, index) in prefix_list"
                :value="item.key"
                :key="index"
                >{{ item.value }}
              </option>
            </select>
            <input
              type="text"
              v-model="user_info_detail.login_phone"
              disabled
            />
            <button
              type="button"
              v-if="
                user_info_detail.login_phone &&
                  user_info_detail.login_phone.length == 0
              "
              @click="showPhoneChangeModal"
            >
              {{ "register.change" | t }}
            </button>
          </div>
        </FormItem>
        <FormItem :label="$t('register.email')">
          <div class="email_c">
            <input
              type="text"
              v-model="user_info_detail.login_email"
              disabled
            />
            <button
              type="button"
              v-if="
                user_info_detail.login_email &&
                  user_info_detail.login_email.length == 0
              "
              @click="showEmailChangeModal"
            >
              {{ "register.change" | t }}
            </button>
          </div>
        </FormItem>
        <FormItem v-if="user_info_detail.is_pwd">
          <div class="">
            {{ $t("user.password") }}
          </div>
          <div style="position:relative; ">
            <Input
              password
              disabled
              :placeholder="$t('register.password')"
              type="password"
              value="********"
            >
            </Input>
            <div
              @click="change_pwd_handler"
              style="padding: 10px;line-height: 12px;cursor: pointer; position:absolute;font-size: 14px;color:#fff;font-weight: 700; border-radius: 2px; background-color: #595959;top:0;right:0;z-index: 2000"
            >
              {{ $t("change_password") }}
            </div>
          </div>
        </FormItem>
        <FormItem :label="$t('register.account_group')">
          <Select
            v-model="user_info_detail.company_code"
            :placeholder="$t('register.select_account_group')"
          >
            <Option
              v-for="(item, index) in company_list"
              :value="item.company_code"
              :key="index"
              >{{ item.company_code }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('register.gender')">
          <RadioGroup v-model="user_info_detail.gender" style="display: block;">
            <Radio
              v-for="(item, index) in gender_list"
              :key="index"
              :label="index"
              >{{ ("register['" + item + "']") | t }}
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem :label="$t('register.area')">
          <Input type="text" v-model="user_info_detail.location"> </Input>
        </FormItem>
        <FormItem :label="$t('register.city')">
          <Input type="text" v-model="user_info_detail.city"> </Input>
        </FormItem>
        <FormItem :label="$t('register.company')">
          <Select
            v-model="user_company"
            :disabled="
              user_info_detail.company != null &&
                user_info_detail.company.length > 0
            "
          >
            <Option
              v-for="(item, index) in user_company_list"
              :value="item.tag_value"
              :key="index"
              >{{ item.tag_value }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('register.language')">
          <Select
            v-model="user_info_detail.language"
            :placeholder="$t('register.select_language')"
          >
            <Option
              v-for="(item, index) in lang_list"
              :value="index"
              :key="index"
              >{{ item }}
            </Option>
          </Select>
        </FormItem>
        <!--        <FormItem :label="$t('register.tag1')">-->
        <!--          <Select-->
        <!--            v-model="tag1_value"-->
        <!--            multiple-->
        <!--            :max-tag-count="1"-->
        <!--            :placeholder="$t('register.tag1')"-->
        <!--          >-->
        <!--            <Option-->
        <!--              v-for="item in tag1_list"-->
        <!--              :value="item.tag_value"-->
        <!--              :key="item.tag_id"-->
        <!--            >{{ item.tag_value }}-->
        <!--            </Option-->
        <!--            >-->
        <!--          </Select>-->
        <!--        </FormItem>-->
        <!--        <FormItem :label="$t('register.tag2')">-->
        <!--          <Select-->
        <!--            v-model="tag2_value"-->
        <!--            multiple-->
        <!--            :max-tag-count="1"-->
        <!--            :placeholder="$t('register.tag2')"-->
        <!--          >-->
        <!--            <Option-->
        <!--              v-for="item in tag2_list"-->
        <!--              :value="item.tag_value"-->
        <!--              :key="item.tag_id"-->
        <!--            >{{ item.tag_value }}-->
        <!--            </Option-->
        <!--            >-->
        <!--          </Select>-->
        <!--        </FormItem>-->
        <!--        <FormItem :label="$t('register.tag3')">-->
        <!--          <Select-->
        <!--            v-model="tag3_value"-->
        <!--            multiple-->
        <!--            :max-tag-count="1"-->
        <!--            :placeholder="$t('register.tag3')"-->
        <!--          >-->
        <!--            <Option-->
        <!--              v-for="item in tag3_list"-->
        <!--              :value="item.tag_value"-->
        <!--              :key="item.tag_id"-->
        <!--            >{{ item.tag_value }}-->
        <!--            </Option-->
        <!--            >-->
        <!--          </Select>-->
        <!--        </FormItem>-->
      </Form>
      <!-- <div>
        <Button type="primary" @click="show_me_drawer = false">
          {{ "session.cancel" | t }}
        </Button>
        <Button type="button" @click="updateMe">
          {{ "session.save" | t }}
        </Button>
      </div> -->

      <div class="drawer-footer">
        <button type="button" @click="close_user_drawer">
          {{ "session.cancel" | t }}
        </button>
        <button type="button" @click="updateMe">
          {{ "session.save" | t }}
        </button>
      </div>
      <div style="margin-top: 20px">
        <Button
          style="background-color:black;color: #ffffff;font-weight: 600;width: 240px;"
          @click="logout"
        >
          {{ $t("session.logout") }}
        </Button>
      </div>
    </Drawer>
    <!-- 修改密码 -->
    <Drawer
      :closable="false"
      v-model="change_pwd_drawer"
      :mask="false"
      class-name="me_style"
      width="280"
    >
      <div style="font-size: 18px;font-weight: 700;">
        {{ $t("change_password") }}
      </div>
      <div class="ivu-form-item-content">
        <Input
          v-show="!is_pwd"
          password
          v-model="login_pwd"
          :disabled="is_pwd"
          :placeholder="$t('register.old_password')"
          type="password"
          style="margin: 10px 0"
        >
        </Input>
        <div v-show="is_pwd">
          <div style="margin: 15px 0; ">
            <Input
              password
              v-model="new_pwd"
              :placeholder="$t('register.new_password')"
              type="password"
            >
            </Input>
            <div style="margin-top: 2px; font-size: 12px;color: #969696">
              {{ $t("register.pwd_placeholder") }}
            </div>
          </div>
          <Input
            password
            v-model="confirm_pwd"
            :placeholder="$t('register.confirm_password')"
            type="password"
          >
          </Input>
        </div>
      </div>

      <div class="drawer-footer" style="margin-top: 20px;">
        <button type="button" @click="verify_password">
          {{ "session.okText" | t }}
        </button>
        <button type="button" @click="change_pwd_drawer = false">
          {{ "session.cancel" | t }}
        </button>
      </div>
    </Drawer>

    <Drawer
      title=""
      :closable="false"
      v-model="change_phone_number_drawer"
      :mask="false"
      class-name="me_style"
      width="280"
    >
      <Form>
        <FormItem :label="$t('register.old_phone')">
          <div class="phone_c">
            <select v-model="user_info_detail.login_phone_prefix" disabled>
              <option
                v-for="(item, index) in prefix_list"
                :value="item.key"
                :key="index"
                >{{ item.value }}
              </option>
            </select>
            <input
              type="text"
              v-model="user_info_detail.login_phone"
              disabled
            />
          </div>
        </FormItem>
        <FormItem :label="$t('register.new_phone')">
          <div class="phone_c">
            <select v-model="update_phone_obj.prefix">
              <option
                v-for="(item, index) in prefix_list"
                :value="item.key"
                :key="index"
                >{{ item.value }}
              </option>
            </select>
            <input type="text" v-model="update_phone_obj.phone" />
          </div>
        </FormItem>
        <FormItem :label="$t('register.validation_code')">
          <div class="phone_c validation_code">
            <input type="text" v-model="update_phone_obj.validation_code" />
            <button
              type="button"
              class="validation"
              @click="send_sms_validation_code"
              :disabled="update_phone_countdown != 60"
            >
              {{ update_phone_btn_txt }}
            </button>
          </div>
        </FormItem>
      </Form>
      <div class="drawer-footer">
        <button type="button" @click="change_phone_number_drawer = false">
          {{ "session.cancel" | t }}
        </button>
        <button type="button" @click="check_sms_validation_code_update_phone">
          {{ "session.save" | t }}
        </button>
      </div>
    </Drawer>

    <Drawer
      title=""
      :closable="false"
      v-model="change_email_drawer"
      :mask="false"
      class-name="me_style"
      width="280"
    >
      <Form>
        <FormItem :label="$t('register.old_email')">
          <div class="email_c">
            <input
              type="text"
              v-model="user_info_detail.login_email"
              disabled
            />
          </div>
        </FormItem>
        <FormItem :label="$t('register.new_email')">
          <div class="email_c">
            <input type="text" v-model="email_validation.email" />
          </div>
        </FormItem>
        <FormItem :label="$t('register.validation_code')">
          <div class="phone_c validation_code">
            <input type="text" v-model="email_validation.code" />
            <button
              type="button"
              class="validation"
              @click="sendEmailValidationCode"
              :disabled="update_phone_countdown != 60"
            >
              {{ update_phone_btn_txt }}
            </button>
          </div>
        </FormItem>
      </Form>
      <div class="drawer-footer">
        <button type="button" @click="change_email_drawer = false">
          {{ "session.cancel" | t }}
        </button>
        <button type="button" @click="validationEmailCode">
          {{ "session.save" | t }}
        </button>
      </div>
    </Drawer>
    <noticeModal
      ref="noticeModal"
      :show.sync="notice.isShow"
      :pop_notice_list.sync="notice.pop_notice_list"
      :unread_count.sync="$store.getters.get_unread_by_total"
      :total_count.sync="notice.total_count"
    ></noticeModal>
    <!-- 裁切头像 -->
    <cropperImg
      ref="cropperImg"
      uploadUrl="user/upload_user_avatar"
      :file="file"
      :title="$t('register.upload_avatar')"
      :options="cropperOptions"
      :width="500"
      :originStyle="{ width: '200px', height: '100px' }"
      :previewStyle="{ width: '100px', height: '100px', borderRadius: '50%' }"
      @onUploadSuccess="
        url => {
          this.user_avatar = url;
          $store.commit('setUserAvatar', url);
        }
      "
    ></cropperImg>
    <!-- 用来展示多个未读消息弹窗 -->
    <Modal
      ref="pop_notice"
      v-model="is_pop_notice"
      width="600"
      class="notice"
      scrollable
      :closable="false"
    >
      <div
        slot="header"
        style="display:flex;justify-content: space-between; align-items: center;margin-bottom: 25px;"
      >
        <div style="display: flex;">
          {{ $t("notice_detail.new_notice") }}
        </div>
        <Icon
          size="20"
          color="#fff"
          style="cursor: pointer;"
          @click="is_pop_notice = false"
          type="md-close"
        />
      </div>
      <div class="all_read">
        <span @click="set_all_readed">{{ $t("notice_detail.all_read") }}</span>
      </div>
      <div class="notice_container" style="height:431px">
        <div style="height:375px">
          <div
            class="message"
            v-for="message in notice.pop_notice_list"
            :key="message.notice_id"
          >
            <div class="info">
              <Badge v-if="!message.is_viewed" dot :offset="[6, 4]">
                <div
                  class="message_type"
                  :style="{
                    color:
                      notice_colors[$refs.noticeModal.get_notice_type(message)]
                  }"
                >
                  {{
                    $t(
                      `notice_detail['${$refs.noticeModal.get_notice_type(
                        message
                      )}']`
                    )
                  }}
                </div>
              </Badge>
              <div
                v-else
                class="message_type"
                :style="{
                  color:
                    notice_colors[$refs.noticeModal.get_notice_type(message)]
                }"
              >
                {{
                  $t(
                    `notice_detail['${$refs.noticeModal.get_notice_type(
                      message
                    )}']`
                  )
                }}
              </div>
              <div class="text">
                <div class="message_title">{{ message.title }}</div>
                <div class="message_time">
                  <!-- 活动名字和会议名字 -->
                  <div
                    style="display:flex;align-items: center;"
                    v-if="message.event_name"
                  >
                    <div
                      class="name"
                      style="display:flex;justify-content: center;"
                    >
                      <div class="event_name">{{ message.event_name }}</div>
                      <div
                        class="session_name"
                        style="display:flex;justify-content: center;"
                        v-if="message.session_name"
                      >
                        <div style="margin:0 3px">{{ ">" }}</div>
                        <div>{{ message.session_name }}</div>
                      </div>
                    </div>
                    <div
                      style="background:rgb(117, 117, 117); width: 2px;height:14px;margin: 0 10px"
                    ></div>
                  </div>
                  <!-- 发送时间 -->
                  <div>
                    {{
                      message.due_time
                        ? message.due_time
                        : message.created_at | formatDate
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="view" @click="viewNoticeDetail(message)">
              {{ $t("notice_detail.view") }}
            </div>
          </div>
        </div>

        <Page
          :total="notice.total_count"
          :page-size="5"
          :current="notice.getNoticeListParams.page_index"
          size="small"
          @on-change="changPage"
          show-total
        />
      </div>
      <div slot="footer"></div>
    </Modal>

    <Modal v-model="showIpadNotice">
      <template #header>
        <div style="color: #fff;">
          {{ $t("ipad_notice_title") }}
        </div>
      </template>
      <div>{{ $t("ipad_notice") }}</div>
      <img
        style="margin-left: 10%;margin-top: 20px;margin-bottom: 20px;"
        src="../static/images/ipad_notice.jpg"
        width="80%"
      />
      <!-- <div #footer></div> -->
      <template #footer>
        <div
          style="display: flex;justify-content: end;align-items: center;gap:10px;"
        >
          <div
            v-show="tipsTimer"
            style="background-color: #f90;color: #fff;border-radius: 4px;padding: 4px 8px;"
          >
            {{ $t("autoClose", { seconds: tipsCount }) }}
          </div>
          <Button
            @click="keepOpen"
            style="margin-right: 10px;background-color: #000;color:#fff;"
          >
            {{ $t("keep_open") }}
          </Button>
        </div>
      </template>
    </Modal>
    <!--用于video的截图,仅适用于阿里云播放器-->
    <canvas v-show="false" id="forSnapShot"></canvas>
    <!-- <v-image :images="[preview_image]" v-show="false" ref="preview"></v-image> -->
  </div>
</template>

<script>
import qs from "qs";
import {
  me,
  update_me,
  upload_user_avatar,
  ping,
  prefix_list,
  gender_list,
  send_sms_validation_code,
  check_sms_validation_code_update_phone,
  begin_user_admin_site_promotion,
  begin_phone_email_verfication,
  end_phone_email_verfication,
  get_user_by_token,
  verfiy_password_login_by_phone,
  verify_old_password
} from "@/api/user";
import { verify_user, verify_password } from "@/api/noauth";
import { get_event_by_attendee } from "@/api/event";
import { get_session_by_announcer_uid } from "@/api/session";

import {
  get_notice_list_by_user,
  get_notice_detail_by_user
} from "@/api/notice";
import { get_all_company } from "@/api/company";
import { query_tags } from "@/api/tag";

import upload_file from "@/components/upload_file";
import UAParser from "ua-parser-js";
import mobile from "is-mobile";
import cropperImg from "@/components/cropper_img";
import noticeModal from "@/components/notice_modal";
import moment from "moment";
import bus from "./libs/bus";
// import { Watermark } from "@pansy/watermark";
import _ from "lodash";
import cookie from "vue-cookies";
import { get_valid_market } from "@/api/app";
import {
  get_access_token_by_openid,
  get_user_openid
} from "./api/authentication";
import vue from "./main";
import ScoreRule from "./components/scoreRule";
import ScoreDetail from "./components/scoreDetail";
import {
  add_integral,
  get_integral_by_user,
  get_user_is_checkin,
  query_integrals
} from "./api/integrals";

export default {
  name: "App",
  components: {
    ScoreDetail,
    ScoreRule,
    "upload-file": upload_file,
    cropperImg,
    noticeModal
  },
  data() {
    return {
      is_pop_notice: false,
      pop_a_notice: false,
      notice_colors: {
        in_station: "#4d4d4d",
        active: "#2D8CFF",
        session: "#31D26F"
      },

      isPollNotice: true,
      notice: {
        isShow: false, //是否展示消息弹框
        is_login: false, //判断是否是登录页面跳转
        unread_count: 0, //未读数
        dataList: [], //所有未读消息
        pop_notice_list: [], //多消息弹框, 一页五个
        total_count: 0, // 搜索到的总条数

        new_notice: {}, //新消息
        getNoticeListParams: {
          is_viewed: "",
          page_index: 1,
          page_size: 10,
          title: ""
        },
        timerId: "" //轮询的定时器
      },
      showIpadNotice: false,
      file: {},
      cropperOptions: {
        toggleDragModeOnDblclick: false,
        guides: false,
        dragMode: "move",
        preview: ".previewImg",
        viewMode: 3
      },
      mobile_menu: "/mobile/passCard",
      is_mobile: false,
      prefix_list: prefix_list,
      is_show_header: false, //是否要显示头部
      is_show_browser: false, //是否显示浏览器下载引导
      browserName: "",
      OS_name: "",
      is_show_home_button: false, //是否显示home Btn
      has_mdtf: false, // event是否有mdtf
      pageHeight: window.innerHeight - 2,
      user_info_detail: {},
      show_me_drawer: false,
      change_phone_number_drawer: false,
      lang_list: {
        en: "ENGLISH",
        cn: "简体中文",
        tw: "繁體中文"
      },
      current_lang: "简体中文",
      company_list: [],
      user_company_list: [],
      user_company: "",
      user_name: "",
      update_phone_obj: {
        phone: "",
        prefix: "+86",
        validation_code: ""
      },
      update_phone_validation_code_interval: new Object(),
      update_phone_btn_txt: this.$t("update_me.get_code"),
      update_phone_countdown: 60,
      gender_list: gender_list,

      //手机号
      change_email_drawer: false,
      email_validation: {
        email: "",
        code: ""
      },

      tag_search_condition: {
        tag_kewords: "",
        category: "",
        page_size: 100,
        page_index: 1
      },

      tag1_list: [],
      tag2_list: [],
      tag3_list: [],
      change_pwd_drawer: false,
      login_pwd: "",
      new_pwd: "",
      confirm_pwd: "",
      is_pwd: false,
      preview_image: "",
      is_ipad: false,
      user_identify_list: [],
      current_user_identify: "",
      current_stage: 0,
      watermark_app: {},
      user_info_tmp: {},
      showScoreRule: false,
      show_score_detail: false,
      score: 0,
      isSign: false,
      tipsTimer: null,
      tipsCount: 3
      // channel_list: []
    };
  },
  computed: {
    user() {
      return this.$store.getters.user_info;
    },
    is_admin() {
      let user_role = this.$store.getters.user_role;
      if (user_role != undefined) {
        return user_role.length > 0;
      } else {
        return false;
      }
    },
    user_avatar: {
      get() {
        if (this.user_info_detail.avatar == null) {
          return "/static/images/icon_avatar.svg";
        } else {
          return this.user_info_detail.avatar;
        }
      },
      set(val) {
        this.user_info_detail.avatar = val;
      }
    },
    tag1_value: {
      get() {
        return this.user_info_detail.tag1 != null
          ? this.user_info_detail.tag1.split(";")
          : [];
      },
      set(val) {
        this.user_info_detail.tag1 = val.join(";");
      }
    },
    tag2_value: {
      get() {
        return this.user_info_detail.tag2 != null
          ? this.user_info_detail.tag2.split(";")
          : [];
      },
      set(val) {
        this.user_info_detail.tag2 = val.join(";");
      }
    },
    tag3_value: {
      get() {
        return this.user_info_detail.tag3 != null
          ? this.user_info_detail.tag3.split(";")
          : [];
      },
      set(val) {
        this.user_info_detail.tag3 = val.join(";");
      }
    },
    isMobilePath() {
      // 被允许的移动端路由（name）
      let arr = [
        "passCard",
        "mobileEventList",
        "me",
        "mobileSessionList",
        "mySport",
        "sportRegister",
        "sportDetail",
        "wonderfulMoments",
        "sportEventList",
        "mobileSession"
      ];
      return arr.indexOf(this.$route.name) != -1;
    },
    current_event_id() {
      return sessionStorage.getItem("current_event_id");
    }
  },
  watch: {
    "$route.name": {
      handler(val) {
        // console.info("$route.name", val)
        let self = this;
        this.is_show_header = this.$route.meta.header;
        this.is_show_home_button = this.$route.meta.header_home_btn;
        this.is_session_footer =
          ["Session", "SessionReport"].indexOf(this.$route.name) >= 0;

        if (self.$route.meta.need_auth == true) {
          // 登录成功后，即可移除验证码重试计数
          localStorage.removeItem("kls_validation_code_retry_count");
          self.getTagList("company", "user_company_list");
          self.getTagList("tag1", "tag1_list");
          self.getTagList("tag2", "tag2_list");
          self.getTagList("tag3", "tag3_list");
          me().then(res => {
            self.user_info_detail = res.body;
            self.user_info_tmp = _.cloneDeep(res.body);
            if (!self.$util.localStorage_getItem("message_bounced")) {
              self.$util.localStorage_setItem("message_bounced", {
                [self.user_info_detail.user_code]: []
              });
            } else {
              if (
                !self.$util.localStorage_getItem("message_bounced")[
                  self.user_info_detail.user_code
                ]
              ) {
                let obj = self.$util.localStorage_getItem("message_bounced");
                obj[self.user_info_detail.user_code] = [];
                self.$util.localStorage_setItem("message_bounced", obj);
              }
            }
            // $cookies.set("userLoginInfo", JSON.stringify(res.body));
            // console.log(res.body,"mememmemememem");
            // self.commit("setUserInfo", res.body)
            self.$store.commit(
              "setLanguage",
              self.user_info_detail.language == null ||
                self.user_info_detail.language == undefined ||
                self.user_info_detail.language == ""
                ? "cn"
                : self.user_info_detail.language
            );
            self.$i18n.locale = self.$store.getters.get_lang;

            console.info("self.$i18n.locale", self.$i18n.locale);

            self.user_name = self.user_info_detail.name;
            self.user_company = self.user_info_detail.company;

            if (self.user_info_detail.login_phone_prefix == null)
              self.user_info_detail.login_phone_prefix = "+86";
            self.update_phone_obj.prefix =
              self.user_info_detail.login_phone_prefix;

            self.$store.commit(
              "setUserEmail",
              self.user_info_detail.login_email
            );
            self.$store.commit(
              "setUserPhone",
              self.user_info_detail.login_phone
            );
          });
          get_all_company().then(res => {
            self.company_list = res.body;
          });
          this.notice.getNoticeListParams.page_size = 0;
          this.get_notice_all_unread();
          if (this.isPollNotice) {
            clearInterval(this.notice.timerId);
            this.notice.timerId = setInterval(() => {
              // this.notice.getNoticeListParams.page_size = 0;
              this.get_notice_all_unread();
            }, 60 * 1000);
          }
        }

        if (self.$store.getters.kls_user_session) {
          get_session_by_announcer_uid().then(res => {
            // console.log(res, "xxxxxxxxxxxxxx")
            this.$store.commit("setChannelList", res.body || []);
            // this.channel_list = res.body || []
            // if(res.body && res.body.length > 0){
            // }
          });
          this.$store.commit("clearPingInterval");
          let session_id = null;
          if (this.$route.name == "Session") {
            session_id = this.$route.params["session_id"];
          }

          if (this.$route.name == "Meeting") {
            session_id = this.$route.params["session_id"];
          }

          if (val !== "Login") {
            self.$store.commit("setPingInterval", () => {
              let t_session = null;
              let tempSession = self.$store.getters.get_assistant_temp_session;
              if (tempSession != null) {
                t_session = tempSession;
              } else {
                t_session = session_id;
              }
              if (self.$route.name == "AssistantMenu") {
                session_id = self.$store.getters.get_current_session_id;
              }
              ping({ session_id: t_session }).then(res => {
                self.$store.commit("setCurrentSessionId", session_id);
                self.$store.commit(
                  "setCurrentSessionStatus",
                  res.body.session_status
                );
              });
            });
          }

          // this.is_login = this.$route.params.is_login;
          // this.notice.is_login = sessionStorage.getItem("is_login");
          // sessionStorage.setItem("is_login", false);
        }
        if (val !== "EventList") {
          self.has_mdtf = sessionStorage.getItem("has_mdtf") == "true";
          this.user_identify_list = JSON.parse(
            sessionStorage.getItem("user_identify_list")
          );
        }
      },
      deep: true,
      immediate: true
    },
    "$i18n.locale": {
      handler(val) {
        // console.log("lang change:", val);
        this.current_lang = this.lang_list[val];
      },
      deep: true,
      immediate: true
    },
    "notice.pop_notice_list": {
      handler(newVal) {
        if (newVal.length === 0) {
          this.is_pop_notice = false;
        }
      },
      deep: true
    },
    show_me_drawer(newVal) {
      if (newVal) {
        try {
          this.getScore();
        } catch (e) {}
      }
    }
  },
  beforeCreate() {
    this.$store.commit("reset_ajax_spin");
  },

  created() {
    // console.log("process.env.NODE_ENV:" + process.env.NODE_ENV);
    this.is_mobile = mobile();
    let self = this;
    let session_key = self.$store.getters.kls_user_session;

    if (self.$route.meta.header == false) {
      self.is_show_header = false;
    } else {
      if (session_key == null) {
        self.is_show_header = false;
      } else {
        self.is_show_header = true;
      }
    }

    self.checkBrowser();

    // self.is_show_header = ((session_key == null) || (self.$route.meta.header == false))
    self.is_show_home_button = self.$route.meta.header_home_btn;
    // this.get_notice_all_unread();
  },
  mounted() {
    let self = this;
    this.current_user_identify = sessionStorage.getItem(
      "current_user_identify"
    );
    bus.$on("reloadIdentify", obj => {
      console.log("reloadIdentify", obj);
      if (obj.current_user_identify != -1) {
        this.current_user_identify = obj.current_user_identify;
        sessionStorage.setItem(
          "current_user_identify",
          obj.current_user_identify
        );
      }
      if (obj.current_stage != -1) {
        this.current_stage = obj.current_stage;
      }
      if (obj.user_identify_list != -1) {
        sessionStorage.setItem(
          "user_identify_list",
          JSON.stringify(obj.user_identify_list)
        );
        this.user_identify_list = obj.user_identify_list;
      }
      if (obj.current_event_id != -1) {
        sessionStorage.setItem("current_event_id", obj.current_event_id);
      }
    });

    bus.$on("check_mdtf", has => {
      console.log("set_has_mdtf", has);
      sessionStorage.setItem("has_mdtf", has);
      self.has_mdtf = has;
    });
    const url_obj = qs.parse(location.search.slice(1));
    // 小程序登录逻辑
    if (url_obj.from == "wx") {
      console.log("location.search", url_obj.code);
      if (url_obj.loginType == "openId") {
        // code:openId
        get_access_token_by_openid({ openid: url_obj.code })
          .then(res => {
            vue.$store.commit("setUserInfo", res.body);
            this.mobileGoTo("mobile/passCard");
            alert(
              "请注意，您现在使用登录的手机号和微信绑定的手机号不同，但您仍可使用我们提供的服务，您可点击用户图标-退出登录，以使用正确的手机号登录，如有疑问请联系管理员。"
            );
          })
          .catch(e => {
            console.log("openid 登录 错误");
            this.$router.push({ name: "Login" });
          });
      } else {
        // code:accessToken
        get_user_openid({ code: url_obj.code })
          .then(res => {
            vue.$store.commit("setUserInfo", res.body);
            if (res.err_code == 0) {
              this.mobileGoTo("mobile/passCard");
            } else {
              console.log("wx phone login 错误");
              this.$router.push({ name: "Login" });
            }
          })
          .catch(e => {
            console.log("wx phone login 错误");
            this.$router.push({ name: "Login" });
          });
      }

      console.log("wx obj", window);
    }

    // ipad 登入逻辑
    if (location.search.indexOf("?token") > -1) {
      this.$cookies.set("is_ipad", true);
      self.is_ipad = true;
      let token = location.search.split("?token=")[1];
      get_user_by_token({ token: token }).then(res => {
        this.$store.commit("setUserInfo", res.body);
        this.$cookies.set("userLoginInfo", JSON.stringify(res.body));
        self.$router.push({ name: "IpadCenter" });
        self.$nextTick(_ => {
          setTimeout(_ => {
            self.$router.go(0);
          }, 1000);
        });
      });
    }
    if (this.$cookies.get("is_ipad")) {
      self.is_ipad = true;
    }

    window.addEventListener("message", msg => {
      // console.log("preview", msg.data);
      if (msg.data.action == "previewImage") {
        if (msg.data.url) {
          self.previewImage(msg.data);
        } else {
          self.previewImage("../暂无图片1.svg");
        }
      }
    });
    // window.onunload = function(e) {
    //   e = e || window.event;
    //   // 兼容IE8和Firefox 4之前的版本
    //   if (e) {
    //     e.returnValue = "关闭提示";
    //     // console.log(123)
    //   }
    //   // console.log(123)
    //   // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
    //   return "关闭提示";
    // };
    self.watchShowNotice();
    window.listenIpadGoback = function() {
      if (this.$router.name == "AssetFrame") {
        self.$router.go(-2);
      } else {
        self.$router.go(-1);
      }
    };
    window.listenIpadRefresh = function() {
      self.$router.go(0);
    };
  },
  beforeDestroy() {
    clearInterval(this.notice.timerId);
    this.watermark_app.destroy && this.watermark_app.destroy();
  },
  methods: {
    keepOpen() {
      clearInterval(this.tipsTimer);
      this.tipsCount = 3;
      this.tipsTimer = null;
    },
    close_user_drawer() {
      this.user_info_detail = _.cloneDeep(this.user_info_tmp);
      this.show_me_drawer = false;
    },
    verify_password() {
      if (!this.is_pwd) {
        verify_old_password({
          pwd: this.login_pwd
        }).then(res => {
          if (res.err_code === 0) {
            this.is_pwd = true;
            this.user_info_detail.old_pwd = this.login_pwd;
          } else {
            this.$util.showError("password_error");
          }
        });
        // verify_password({
        //   login_phone:
        //     this.user_info_detail.login_phone_prefix +
        //     this.user_info_detail.login_phone,
        //   password: this.login_pwd
        // }).then(res => {
        //   if (res.body.is_pwd) {
        //     this.is_pwd = true;
        //   } else {
        //     this.$util.showError("password_error");
        //   }
        // });
      } else {
        const pwd_reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,}$/;
        if (this.new_pwd == null || this.new_pwd.length == 0) {
          this.$util.showError("PASSWORD IS REQUIRED");
          return;
        }
        if (!pwd_reg.test(this.new_pwd)) {
          this.$util.showError("BAD PASSWORD FORMAT");
          return;
        }
        if (this.new_pwd !== this.confirm_pwd) {
          this.$util.showError("TWO DIFFERENT PASSWORDS");
          return;
        }
        this.user_info_detail.login_account_pwd = this.new_pwd;
        update_me(this.user_info_detail).then(res => {
          this.show_me_drawer = false;
          this.change_pwd_drawer = false;
          this.$util.showSuccess("change_password_success");
          this.$util.add_action_log("password", { action: "change_success" });
        });
      }
    },
    identify_text(iden) {
      let t;
      switch (iden) {
        case "is_partner_contacter":
          t = "portal.partner_contact";
          break;
        case "broadcaster":
          t = "portal.broadcaster";
          break;
        case "is_assistant":
          t = "portal.assistant";
          break;
        case "is_speaker":
          t = "litter_helper.speaker";
          break;
        default:
          t = "portal.attendee";
          break;
      }
      return t;
    },
    changeIdentify(iden) {
      this.current_user_identify = iden;
      sessionStorage.setItem("current_user_identify", iden);
      switch (iden) {
        case "is_partner_contacter":
          this.$router.push(
            "/InvitationList/" + sessionStorage.getItem("current_event_id")
          );
          this.$store.commit("setHelperRoles", 4);
          break;
        // case "broadcaster":
        //   this.$router.push("/ChannelList/" + this.current_event_id);
        //   this.$store.commit("setHelperRoles", 3);
        //   break;
        case "is_assistant":
          get_event_by_attendee({
            evt_id: sessionStorage.getItem("current_event_id"),
            is_assistant: true
          }).then(res => {
            if (res.body.t_session_attendee.length > 0) {
              this.$router.push(
                "/AssistantMenu/" + sessionStorage.getItem("current_event_id")
              );
              this.$store.commit("setHelperRoles", 6);
            } else {
              this.$Message.warning(this.$t("session.QA.noSession"));
            }
          });
          break;
        case "is_speaker":
          this.$router.push({
            name: "EventDetail",
            params: { event_id: sessionStorage.getItem("current_event_id") }
          });
          this.$store.commit("setHelperRoles", "2,5");
          break;
        default:
          this.$router.push({
            name: "EventDetail",
            params: { event_id: sessionStorage.getItem("current_event_id") }
          });
          this.$store.commit("setHelperRoles", 2);
          this.$util.add_action_log("event", {
            action: "toDetail",
            event_id: sessionStorage.getItem("current_event_id")
          });
          break;
      }
    },
    getScore() {
      get_integral_by_user({}).then(res => {
        this.score = res.body;
      });
      get_user_is_checkin({}).then(res => {
        this.isSign = res.body;
      });
    },
    showScoreDetail() {
      this.show_score_detail = !this.show_score_detail;
    },
    signIn() {
      let params = { type: 0, integral: 5, content: "签到" };
      add_integral(params).then(res => {
        this.getScore();
      });
    },
    change_pwd_handler() {
      this.change_pwd_drawer = true;
      this.is_pwd = false;
      (this.login_pwd = ""), (this.new_pwd = "");
      this.confirm_pwd = "";
    },
    previewImage(data) {
      // this.preview_image = data.url;
      // this.$refs.preview.view(0);

      this.$hevueImgPreview({ url: data.url });

      this.$nextTick(() => {
        let heEl = document.querySelector(".he-img-wrap");
        // this.$toggleWatermark(true, {
        //   text:
        //     this.$store.getters.user_name.toUpperCase() +
        //     " " +
        //     this.$store.getters.user_phone,
        //   fontSize: "25px",
        //   density: 1,
        //   oddStyle: {
        //     color: "#333",
        //     opacity: "0.3"
        //   },
        //   evenStyle: {
        //     color: "#ccc",
        //     opacity: "0.15"
        //   },
        //   container: heEl
        // });
        // this.watermark_app = new Watermark({
        //   text:
        //     this.$store.getters.user_name.toUpperCase() +
        //     " " +
        //     this.$store.getters.user_phone,
        //   zIndex: 19999,
        //   fontColor: "#ccc",
        //   container: heEl,
        //   monitor: true,
        //   opacity: 0.3
        // });
      });
    },
    // 全部已读
    set_all_readed() {
      this.$refs.noticeModal.set_all_readed();
      // this.notice.unread_count = 0;
      this.$store.commit("set_unread_count", { type: "total", count: 0 });

      this.is_pop_notice = false;
      sessionStorage.setItem("unread_count", 0);
      this.$util.add_action_log("notice", { action: "set_all_readed" });
    },
    viewNoticeDetail(message) {
      this.$refs.noticeModal.viewNoticeDetail(message);
      this.$util.add_action_log("notice", {
        action: "show_notice_detail",
        message_id: message
      });
      // }
    },
    // 分页
    changPage(index) {
      this.notice.getNoticeListParams.page_index = index;
      this.get_notice_by_pop();
    },
    noticeMessage(content) {
      // this.$Notice.config({
      //   top: 70,
      //   duration: 5
      // });
      this.$Notice.open({
        name: content.notice_id,
        duration: 10000000,
        render: h => {
          return h(
            "div",
            {
              style: {}
            },
            [
              // 标题
              h(
                "div",
                {
                  style: {
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#fff",
                    display: "flex",
                    alignItems: "space-between"
                  }
                },
                [
                  h("img", { attrs: { src: "../static/images/warning.svg" } }),
                  h(
                    "div",
                    {
                      style: {
                        width: "304px",
                        // flex: "1",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        marginLeft: "10px",
                        lineHeight: "30px"
                      }
                    },
                    content.title
                  ),
                  h("Icon", {
                    style: {
                      cursor: "pointer"
                    },
                    props: {
                      type: "ios-close",
                      color: "#fff",
                      size: "30"
                    },
                    on: {
                      click: () => {
                        this.$Notice.close("test");
                        this.$Notice.destroy("test");
                      }
                    }
                  })
                ]
              ),
              // 基本信息
              h(
                "div",
                {
                  style: {
                    display: "flex",
                    marginTop: "5px",
                    alignItems: "center",
                    fontSize: "12px",
                    marginLeft: "30px",
                    color: "#d9d9d9"
                  }
                },
                [
                  content.event_name
                    ? h(
                        "div",
                        { style: { display: "flex", alignItems: "center" } },
                        [
                          h(
                            "div",
                            {
                              style: {
                                display: "flex",
                                justifyContent: "center"
                              }
                            },
                            [
                              h("div", content.event_name),
                              content.session_name
                                ? h(
                                    "div",
                                    {
                                      style: {
                                        display: "flex",
                                        justifyContent: "center"
                                      }
                                    },
                                    [
                                      h(
                                        "div",
                                        { style: { margin: "0 3px" } },
                                        ">"
                                      ),
                                      h("div", content.session_name)
                                    ]
                                  )
                                : ""
                            ]
                          ),
                          h("div", {
                            style: {
                              background: "rgb(117, 117, 117)",
                              width: "2px",
                              height: "10px",
                              margin: "0 10px"
                            }
                          })
                        ]
                      )
                    : "",
                  h(
                    "div",
                    {
                      style: {
                        color: "#F4F4F4",
                        fontSize: "14px"
                      }
                    },
                    this.$util.formatTime(
                      content.due_time ? content.due_time : content.created_at,
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  )
                ]
              ),
              // 按钮
              h(
                "div",
                {
                  style: {
                    textAlign: "right",
                    marginTop: "10px"
                  }
                },
                [
                  h(
                    "button",
                    {
                      style: {
                        // width: "64px",
                        padding: "3px 8px",
                        lineHeight: "24px",
                        color: "#D9D9D9",
                        background: "#4D4D4D",
                        borderRadius: "5px",
                        marginRight: "5px",
                        border: "none",
                        cursor: "pointer"
                      },
                      on: {
                        click: () => {
                          this.$Notice.close(content.notice_id);
                          this.$Notice.destroy(content.notice_id);
                          // this.know(content);
                        }
                      }
                    },
                    this.$t("litter_helper.i_know")
                  ),
                  h(
                    "button",
                    {
                      style: {
                        // width: "64px",
                        // height: "24px",
                        padding: "3px 8px",
                        lineHeight: "24px",
                        color: "#fff",
                        background: "#DE6712",
                        borderRadius: "5px",
                        border: "none",
                        cursor: "pointer"
                      },
                      on: {
                        click: () => {
                          this.$refs.noticeModal.viewNoticeDetail(content);
                          this.$Notice.close(content.notice_id);
                          this.$Notice.destroy(content.notice_id);
                          // this.$refs.noticeModal.viewDetail()
                          // console.log("查看详情");
                        }
                      }
                    },
                    this.$t("view_detail")
                  )
                ]
              )
            ]
          );
        },
        onClose: () => {
          // console.log("弹窗关闭")
          if (!this.user_info_detail.user_code) {
            return;
          }
          const message_bounced = this.$util.localStorage_getItem(
            "message_bounced"
          );
          message_bounced[this.user_info_detail.user_code].unshift(
            content.notice_id
          );
          this.$util.localStorage_setItem("message_bounced", message_bounced);
        }
      });
    },
    // 展示公告
    showNotice() {
      this.notice.isShow = true;
      this.$util.add_action_log("notice", { action: "show_notice" });
    },
    watchShowNotice() {
      bus.$on("watchShowNotice", show => {
        this.notice.isShow = !this.notice.isShow;
      });
    },

    gotoMDTF() {
      // this.showIpadNotice = true;
      // this.tipsTimer = setInterval(() => {
      //   this.tipsCount--;
      //   if (this.tipsCount == 0) {
      //     clearInterval(this.tipsTimer);
      //     this.tipsCount = 3;
      //     this.showIpadNotice = false;
      //   }
      // }, 1000);
      // return;
      // 判断是否网页由ipad打开
      // this.$Message.info( navigator.userAgent.toLowerCase())
      console.log(navigator.userAgent.toLowerCase());
      let ua = navigator.userAgent.toLowerCase();
      let isPC = !/mac/i.test(ua);
      // console.log( isPC)
      if (!isPC) {
        this.showIpadNotice = true;
        this.tipsTimer = setInterval(() => {
          this.tipsCount--;
          if (this.tipsCount == 0) {
            clearInterval(this.tipsTimer);
            this.tipsCount = 3;
            this.showIpadNotice = false;
          }
        }, 1000);
      }
      let obj = {
        session_key: this.$store.getters.kls_user_session,
        from_type: "mdtf",
        event_id: sessionStorage.getItem("current_event_id"),
        emoment_uid: this.$store.getters.user_id
      };
      this.$util.add_action_log("pal", {
        action: "gotoPAL",
        event_id: sessionStorage.getItem("current_event_id")
      });
      let url = "";
      get_valid_market({
        event_id: sessionStorage.getItem("current_event_id"),
        scene_code: "u_session_attendee"
      }).then(res => {
        console.log("get_valid_market", res);
        if (process.env.NODE_ENV == "development") {
          url = "http://localhost:8082/apps/da";
        } else {
          url = res.body[0].launch_url;
        }
        let w = window.open(url + "/KIT?" + qs.stringify(obj));
        if (!w) {
          this.showIpadNotice = true;
        }
      });
    },
    // 获取所有未读
    get_notice_all_unread() {
      // if (!this.user_info_detail.user_code) {
      //   return;
      // }
      this.notice.getNoticeListParams.page_size = 5;
      this.get_notice_list_by_user(res => {
        // this.notice.unread_count = res.body.unread_notice_count;
        this.$store.commit("set_unread_count", {
          type: "total",
          count: res.body.unread_notice_count
        });
        this.notice.total_count = res.body.unread_notice_count;
        // this.notice.dataList = res.body.notice_list;
        let unread_count = +sessionStorage.getItem("unread_count") || 0;

        this.notice.is_login = JSON.parse(sessionStorage.getItem("is_login"));
        //需要排除的 url
        const excludeUrl = ["/Register", "/Media", "/mobile"];
        if (this.notice.is_login && res.body.notice_list.length <= 1) {
          this.notice.is_login = false;
          return;
        }
        // 如果多消息弹框没有关闭
        if (this.is_pop_notice) {
          this.notice.is_login = true;
        }
        // 刚登陆的时候弹出未读消息框
        if (
          this.notice.is_login &&
          res.body.notice_list.length > 1 &&
          this.$store.state.finish_training
        ) {
          this.is_pop_notice = true;
          this.notice.getNoticeListParams.page_index = 1;
          this.get_notice_by_pop();
          sessionStorage.setItem("is_login", false);
          this.notice.is_login = false;
          sessionStorage.setItem(
            "new_notice_id",
            res.body.notice_list[0].notice_id
          );
          return;
        }
        // console.log(res.body.notice_list.length > unread_list.length);
        if (res.body.unread_notice_count > unread_count) {
          this.isPollNotice = true;
          //控制其他页面不出现消息弹框
          if (excludeUrl.some(url => location.href.indexOf(url) > 0)) {
            // this.notice.is_login = sessionStorage.getItem("is_login");
            // sessionStorage.setItem("is_login", false);
            clearInterval(this.notice.timerId);
            this.isPollNotice = false;
            return;
          }
          // 取出新消息
          this.notice.new_notice = res.body.notice_list[0];
          if (
            res.body.notice_list[0].notice_id !==
            +sessionStorage.getItem("new_notice_id")
          ) {
            // 对新消息的类型进行判断
            if (this.notice.new_notice.reminder_type === 2) {
              this.noticeMessage(this.notice.new_notice);
            } else {
              this.is_pop_notice = true;
              this.notice.pop_notice_list = res.body.notice_list;
            }
          }
        }
        sessionStorage.setItem("unread_count", res.body.unread_notice_count);
      });
    },
    // 获取弹出消息列表
    get_notice_by_pop() {
      this.notice.getNoticeListParams.page_size = 5;
      this.get_notice_list_by_user(res => {
        this.notice.pop_notice_list = res.body.notice_list;
        this.notice.total_count = res.total_count;
        // 修改弹窗的位置
        // this.$nextTick(() => {
        //   const ive_modal = this.$refs.pop_notice.$el.querySelector(
        //     ".ivu-modal"
        //   );
        //   this.pop_notice_top = `calc((100vh - ${ive_modal.offsetHeight}px) / 2)`;
        // });
      });
    },
    // 获取公告列表
    get_notice_list_by_user(cb) {
      this.notice.getNoticeListParams.is_viewed = false;
      get_notice_list_by_user(this.notice.getNoticeListParams).then(res => {
        cb(res);
      });
    },
    mobileGoTo(path) {
      let self = this;
      console.log(path);
      this.$router.push({
        path: path
      });
      if (path.indexOf("passCard") >= 0) {
        this.$util.add_action_log("mobileTab", { action: "switchToPassCard" });
      }
    },
    gotoAdminPortal() {
      begin_user_admin_site_promotion().then(res => {
        window.open(
          process.env.ADMIN_PORTAL_URL +
            "?from=jump&promotion_code=" +
            res.body.code
        );
      });
    },
    gotoEventList() {
      // location.href = "/EventList";
      if (this.is_ipad) {
        this.$router.push("/IpadCenter");
      } else {
        this.$router.push("/EventList");
      }
    },
    logout() {
      let self = this;
      this.$util.add_action_log("logout", { action: "logout" });
      setTimeout(() => {
        self.$store.commit("setUserInfo", {});
        // sessionStorage.setItem("is_login", true);
        // 清除所有 sessionstorage
        clearInterval(self.notice.timerId);
        sessionStorage.clear();
        location.href = "/";
      }, 100);
    },
    updateMe() {
      let self = this;
      if (self.user_company != "" && self.user_company != null) {
        self.user_info_detail.company = self.user_company;
      }
      update_me(self.user_info_detail).then(res => {
        self.$i18n.locale = self.user_info_detail.language;
        // console.log("lang:======>>>>>", self.user_info_detail.language);
        self.$store.commit("setLanguage", self.user_info_detail.language);
        self.show_me_drawer = false;
        self.user_name = self.user_info_detail.name;
        self.$store.commit("setUsername", self.user_name);
        this.$util.add_action_log("personal", {
          action: "updateme",
          info: self.user_info_detail
        });
        this.$router.go(0);
      });
      this.$util.add_action_log("personal", {
        action: "updateme",
        info: self.user_info_detail
      });
    },
    switchLang(name) {
      if (this.current_lang == "ENGLISH") {
        this.$util.add_action_log("language", {
          action: "switchLang",
          from: "en",
          to: name
        });
      } else if (this.current_lang == "简体中文") {
        this.$util.add_action_log("language", {
          action: "switchLang",
          from: "cn",
          to: name
        });
      } else {
        this.$util.add_action_log("language", {
          action: "switchLang",
          from: "tw",
          to: name
        });
      }
      this.$i18n.locale = name;
      this.user_info_detail.language = name;
      this.updateMe();
      // this.$router.go(0)
    },
    uploadAvatar(e) {
      if (
        !["image/png", "image/jpg", "image/jpeg"].includes(
          e.target.files[0].type
        )
      ) {
        this.$util.showError(
          "the image you uploaded is not in the right format"
        );
        return;
      }
      let formdata = new FormData();
      formdata.append("file", e.target.files[0]);
      this.file = e.target.files[0];
      let data = window.URL.createObjectURL(new Blob([this.file]));

      if (this.$refs.cropperImg.cropper) {
        this.$refs.cropperImg.cropper.replace(data);
      }
      this.$refs.cropperImg.cropper.setAspectRatio(1);
      this.$refs.cropperImg.open();
      // upload_user_avatar(formdata)
      //   .then(res => {
      //     this.user_avatar = res.body;
      //     this.$store.commit("setUserAvatar", this.user_avatar);
      //     this.$refs["upload_avatar"].clearValue();
      //   })
      //   .catch(res => {
      //     this.$refs["upload_avatar"].clearValue();
      //   });
      this.$util.add_action_log("personal", { action: "changeAvatar" });
    },

    showPhoneChangeModal() {
      this.change_phone_number_drawer = true;
      this.update_phone_obj.prefix = this.user_info_detail.login_phone_prefix;
      this.update_phone_obj.phone = "";
      this.update_phone_obj.validation_code = "";
    },
    send_sms_validation_code() {
      let self = this;
      if (self.update_phone_obj.phone.length == 0) {
        self.$util.showError("no_phone");
        return;
      }
      if (self.update_phone_obj.phone == self.user_info_detail.login_phone) {
        self.$util.showError("same_phone");
        return;
      }
      send_sms_validation_code(self.update_phone_obj).then(res => {
        self.update_phone_btn_txt = this.$t("update_me.count_down", {
          second: self.update_phone_countdown
        });
        self.update_phone_countdown--;
        self.update_phone_validation_code_interval = setInterval(() => {
          self.update_phone_countdown--;
          if (self.update_phone_countdown <= 0) {
            clearInterval(self.update_phone_validation_code_interval);
            self.update_phone_btn_txt = this.$t("update_me.get_code");
            self.update_phone_countdown = 60;
          } else {
            self.update_phone_btn_txt = this.$t("update_me.count_down", {
              second: self.update_phone_countdown
            });
          }
        }, 1000);
      });
    },
    check_sms_validation_code_update_phone() {
      let self = this;
      if (self.update_phone_obj.phone.length == 0) {
        self.$util.showError("no_phone");
        return;
      }
      if (self.update_phone_obj.validation_code.length == 0) {
        self.$util.showError("no_validation_code");
        return;
      }
      check_sms_validation_code_update_phone(self.update_phone_obj).then(
        res => {
          self.$store.commit("setUserPhone", self.update_phone_obj.phone);
          me().then(res => {
            console.log(self.user_info_detail);
            self.user_info_detail = res.body;
            self.user_info_tmp = _.cloneDeep(res.body);
            self.change_phone_number_drawer = false;
            clearInterval(self.update_phone_validation_code_interval);
            self.update_phone_btn_txt = this.$t("update_me.get_code");
            self.update_phone_countdown = 60;
          });
        }
      );
    },
    showEmailChangeModal() {
      this.change_email_drawer = true;
      this.email_validation = {
        email: "",
        code: ""
      };
    },
    sendEmailValidationCode() {
      let self = this;
      if (self.email_validation.email.length == 0) {
        self.$util.showError("no_email");
        return;
      }
      if (self.user_info_detail.login_email == self.email_validation.email) {
        self.$util.showError("same_email");
        return;
      }
      begin_phone_email_verfication(self.email_validation).then(res => {
        self.update_phone_btn_txt = this.$t("update_me.count_down", {
          second: self.update_phone_countdown
        });
        self.update_phone_countdown--;
        self.update_phone_validation_code_interval = setInterval(() => {
          self.update_phone_countdown--;
          if (self.update_phone_countdown <= 0) {
            clearInterval(self.update_phone_validation_code_interval);
            self.update_phone_btn_txt = this.$t("update_me.get_code");
            self.update_phone_countdown = 60;
          } else {
            self.update_phone_btn_txt = this.$t("update_me.count_down", {
              second: self.update_phone_countdown
            });
          }
        }, 1000);
      });
    },
    validationEmailCode() {
      let self = this;
      if (self.email_validation.code.length == 0) {
        self.$util.showError("no_validation_code");
        return;
      }
      end_phone_email_verfication(self.email_validation).then(res => {
        self.user_info_detail.login_email = self.email_validation.email;
        update_me(self.user_info_detail).then(res => {
          self.$store.commit("setUserEmail", self.email_validation.email);
          me().then(res => {
            self.user_info_detail = res.body;
            self.change_email_drawer = false;
            clearInterval(self.update_phone_validation_code_interval);
            self.update_phone_btn_txt = this.$t("update_me.get_code");
            self.update_phone_countdown = 60;
          });
        });
      });
    },
    // 获取tag list
    getTagList(tag_name, list) {
      let self = this;
      self.tag_search_condition.category = tag_name;
      query_tags(self.tag_search_condition).then(res => {
        self[list] = res.body;
      });
    },
    checkBrowser() {
      let self = this;

      let test_mobile = mobile();
      if (test_mobile == true) {
        return; //手机上不限制（邀请页支持手机，且页面跳转时有判断页面是否支持手机）
      }

      var parser = new UAParser();
      var browserName = parser.getBrowser().name;
      // console.log("browserName", browserName);
      if (
        browserName.indexOf("Chrome") > -1 ||
        browserName.indexOf("Firefox") > -1 ||
        browserName.indexOf("Safari") > -1 ||
        browserName == "Edge" ||
        browserName == "WaterFox" ||
        browserName == "WebKit"
      ) {
        self.is_show_browser = false;
      } else {
        self.browserName = browserName;
        self.is_show_browser = true;
      }
      var OS_Name = parser.getOS().name;
      if (OS_Name == "Mac OS") {
        self.OS_name = "mac";
      } else if (OS_Name.indexOf("Windows") > -1) {
        self.OS_name = "windows";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.icon_center {
  position: absolute;
  left: calc(50% - 55px);
}

.icon_right {
  position: absolute;
  right: 0;
}

/deep/ .ivu-badge-count {
  min-width: 10px;
  padding: 5px 2px;
  height: 10px;
  border-radius: 10px;
  line-height: 1px;
}

/deep/ .ivu-badge-dot {
  background: #de6712;
}

// .ivu-notice {
//   top: 70px !important;
// }
.notice {
  /deep/ .ivu-modal-header {
    padding-bottom: 0;
    border-bottom: none;
    padding: 0px;
    font-size: 16px;
    color: #fff;
  }

  /deep/ .ivu-modal {
    // transform: translateY(-50%);
    top: 50%;
    transform: translateY(-50%);
  }

  .all_read {
    text-align: right;
    // display:flex;
    // align-items: center;
    color: #2d8cff;
    margin: 10px 0;
    margin-right: 10px;

    span {
      cursor: pointer;
    }
  }

  /deep/ .ivu-modal-close {
    top: 28px;
    right: 35px;
  }

  /deep/ .ivu-modal-header {
    padding-top: 0px;
  }

  /deep/ .ivu-modal-content {
    padding: 20px;
    background: #171717;
  }

  /deep/ .ivu-modal-body {
    padding: 0px;
    // margin-top: 20px;
    .message {
      display: flex;
      height: 66px;
      flex-direction: row;
      align-items: center;
      padding: 8px 4px;
      background: #303030;
      padding-left: 10px;
      border-left: 2px solid #de6712;
      // height: 60px;
      // border-bottom: 1px solid #4d4d4d;
      margin-bottom: 10px;

      .ivu-badge-dot {
        width: 12px;
        height: 12px;
      }

      .info {
        display: flex;
        flex: 1;
        flex-direction: row;
        align-items: center;
        padding: 0px;
        width: 296px;
        // height: 50px;
        .message_type {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          // padding: 10px;
          width: 50px;
          height: 50px;
          font-size: 12px;
          font-weight: 600;
          /* 100 */
          background: #ffffff;
          border-radius: 50%;
        }

        .text {
          margin-left: 15px;
          flex: 1;
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          .message_title {
            color: #d9d9d9;
            width: 400px;
            font-size: 16px;
            font-weight: 700;
            white-space: nowrap; /* 不换行 */
            overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
            text-overflow: ellipsis;
          }

          .message_time {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #d9d9d9;
          }
        }
      }

      .view {
        width: 55px;
        margin-right: 10px;
        // height: 22px;
        padding: 5px;
        color: #fff;
        text-align: center;
        transition: all 0.5s;
        /* 85 */
        background: #de6712;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
          // color: #d9d9d9;
          // background: #000;
        }
      }
    }

    .ivu-page {
      margin-top: 15px;
      color: #d9d9d9;
      text-align: right;

      .ivu-page-prev,
      .ivu-page-next {
        background: #171717;

        &:hover a {
          color: #2d8cf0;
        }

        a {
          color: #d9d9d9;
        }
      }

      .ivu-page-disabled {
        a {
          color: #8b8383;
        }

        &:hover a {
          color: #8b8383;
        }
      }

      .ivu-page-item {
        background: #171717;

        &:hover a {
          color: #2d8cf0;
        }

        a {
          color: #d9d9d9;
        }
      }

      .ivu-page-item-active a {
        color: #2d8cf0;
      }
    }
  }

  /deep/ .ivu-modal-footer {
    border-top: none;
    padding: 0;
  }
}

.user_identify {
  height: 70px;
}

.pop_a_notice {
  /deep/ .ivu-modal-header {
    padding-bottom: 0;
    border-bottom: none;
    padding: 0px;
    font-size: 16px;
    color: #fff;
  }

  /deep/ .ivu-modal-close {
    top: 28px;
    right: 35px;
  }

  /deep/ .ivu-modal-header {
    padding-top: 0px;
  }

  /deep/ .ivu-modal-content {
    padding: 20px;
    background: #171717;
  }

  /deep/ .ivu-modal {
    top: calc((100vh - 151px) / 2);
  }

  /deep/ .ivu-modal-body {
    padding: 0px;
    // margin-top: 20px;
  }

  /deep/ .ivu-modal-footer {
    border-top: none;
    padding: 0;
  }

  .message {
    display: flex;
    height: 66px;
    flex-direction: row;
    align-items: center;
    padding: 8px 4px;
    background: #303030;
    padding-left: 10px;
    border-left: 2px solid #de6712;
    // height: 60px;
    // border-bottom: 1px solid #4d4d4d;
    margin-bottom: 10px;

    .ivu-badge-dot {
      width: 12px;
      height: 12px;
    }

    .info {
      display: flex;
      flex: 1;
      flex-direction: row;
      align-items: center;
      padding: 0px;
      width: 296px;
      // height: 50px;
      .message_type {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        // padding: 10px;
        width: 50px;
        height: 50px;
        font-size: 12px;
        font-weight: 600;
        /* 100 */
        background: #ffffff;
        border-radius: 50%;
      }

      .text {
        margin-left: 15px;
        flex: 1;
        height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .message_title {
          color: #d9d9d9;
          width: 400px;
          font-size: 16px;
          font-weight: 700;
          white-space: nowrap; /* 不换行 */
          overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
          text-overflow: ellipsis;
        }

        .message_time {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #d9d9d9;
        }
      }
    }

    .view {
      width: 55px;
      margin-right: 10px;
      // height: 22px;
      padding: 5px;
      color: #fff;
      text-align: center;
      transition: all 0.5s;
      /* 85 */
      background: #de6712;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        // color: #d9d9d9;
        // background: #000;
      }
    }
  }
}

/deep/ .ivu-modal-content {
  background-color: rgba(17, 17, 17, 0.5);
  .ivu-modal-body {
    color: white;
  }
}

/deep/.ivu-modal-header {
  .ivu-modal-header-inner {
    color: white;
  }
}
/deep/ .ivu-modal-close {
  z-index: 1000;
}
</style>

<style lang="less">
html {
  background: #242424;
  // body {
  //   background: #2c3e50;
  // }
}

body {
  overflow: auto !important;
}

* {
  font-family: OneNikeCurrency, "FuturaW01-ExtraBoldCond 774896",
    Futura-CondensedMedium, Roboto-Condensed-Light;
  // font-family: Tahoma;
}

#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: OneNikeCurrency, "FuturaW01-ExtraBoldCond 774896",
    Futura-CondensedMedium, Roboto-Condensed-Light;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;

  .no_bg {
    background: #242424;
  }

  .ivu-layout-header {
    // overflow:hidden;
    background: #000;
    padding: 0 20px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    height: 70px;
    display: flex;
    justify-content: space-between;

    h2 {
      color: #fff;
      float: left;
      width: 200px;
      text-align: left;
      font-size: 50px;
      font-weight: normal;
      height: 70px;
      line-height: 70px;
      margin-top: 0;
      padding: 0;
    }

    .item {
      float: right;
      margin: 0 3px;
      text-align: center;
      height: 70px;
      padding: 10px;
      cursor: pointer;

      h5 {
        color: #fff;
        font-size: 16px;
        line-height: 16px;
        font-weight: normal;

        &.down {
          padding-right: 20px;
          background: url("/static/images/icon_down.svg") no-repeat right center;
        }

        &.pal_enter {
          width: 50px;
          text-align: left;
          line-height: 1.1;
        }
      }

      img {
        width: 26px;
        height: 26px;
        border-radius: 13px;
        display: block;
        margin: 0 auto;
        margin-bottom: 10px;
      }

      &.user {
        img {
          border: 2px solid #fff;
          background: #999;
        }
      }

      &.logout {
        .icon_btn {
          display: block;
          font-size: 26px;
          color: #fff;
          margin-bottom: 10px;
        }
      }

      &.language {
        .ivu-dropdown {
          display: block;

          .ivu-dropdown-rel {
            height: 16px;

            a {
              color: #fff;
              display: block;
              font-size: 16px;
              line-height: 16px;
              padding-right: 20px;
              background: url("/static/images/icon_down.svg") no-repeat right
                center;
            }
          }
        }
      }
    }

    button {
      float: right;
      margin-top: 16px;
    }
  }

  .footer_meetingzen {
    padding: 0;
    line-height: 40px;
    text-align: right;
    padding-right: 10px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background: #242424;
    color: #757575;
    font-size: 14px;

    a {
      color: #757575;
      margin-right: 20px;

      &:hover {
        text-decoration: underline;
      }
    }

    &.session_footer {
      background: #000;
    }
  }

  .container {
    padding-top: 120px;
    padding-bottom: 80px;
  }

  .ivu-btn-primary {
    background-color: #000;
    border-color: #000;

    &:hover {
      background-color: #333;
      border-color: #333;
    }
  }
}

.me_style {
  .ivu-drawer-content {
    .ivu-drawer-header-inner {
      color: #fff;
    }
    .ivu-select-dropdown {
      z-index: 2001;
    }
    background: #000;
    color: #fff;
    height: calc(100vh - 70px);
    top: auto;
    border-radius: 0px 0px 6px 6px;
    box-shadow: 0px 2px 15px -1px rgba(0, 0, 0, 0.65);

    .ivu-drawer-body {
      position: relative;
      // padding-bottom: 60px;
      .ivu-form-item-content {
        .ivu-icon-ios-eye-off-outline,
        .ivu-icon-ios-eye-outline {
          color: #fff;
        }

        input {
          background: #303030;
          color: #fff;
          border-color: #303030;
        }

        .ivu-input-word-count {
          background: none;
          color: #fff;
        }

        .ivu-select-selection {
          border-color: #303030;
          background-color: #303030;
        }

        .ivu-select-selected-value {
          background: #303030;
          color: #fff;
        }
      }

      .avatar_c {
        /*text-align: center;*/
        .scoreRule {
          position: absolute;
          top: 30px;
          left: -120px;
          width: 250px;
          z-index: 2001;
        }
        .scoreDetail {
          position: absolute;
          top: 70px;
          left: -125px;
          width: 270px;
          z-index: 2001;
        }
        .close_icon {
          position: absolute;
          cursor: pointer;
          &:hover {
            background-color: white;
            color: black;
            border-radius: 10px;
          }
        }
        .img {
          width: 60px;
          height: 60px;
          border-radius: 30px;
          /*margin: 0 auto;*/
          background: #999 no-repeat center center;
          background-size: cover;
        }

        .sign_up {
          button {
            background: #e89700;
            border-color: #db9000;
            transition: 0.5s;
            outline: none;
            color: white;
            height: 24px;
            margin-top: 10px;
            &:hover {
              background: #a16c07;
            }
          }
        }

        .upload_avatar {
          margin-top: 10px;

          button {
            background: #303030;
            border-color: #303030;
            transition: 0.5s;
            outline: none;

            &:hover {
              background: #505050;
            }
          }
        }

        .question_icon {
          border: 2px solid white;
          border-radius: 10px;
          position: relative;
          top: -3px;
          margin-left: 5px;
          cursor: pointer;
        }
      }

      .ivu-form-item-label {
        display: block;
        width: 100%;
        text-align: left;
        color: #fff;
      }

      .phone_c {
        position: relative;

        select {
          color: #fff;
          border: 0;
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 100;
          background: #303030;
          height: 32px;
          width: 50px;
          border-radius: 4px 0 0 4px;
          outline: none;

          &:disabled {
            cursor: not-allowed;
          }
        }

        input {
          background: #303030;
          height: 32px;
          border-radius: 4px;
          padding-left: 60px;
          width: 100%;
          outline: none;
          border: none;

          &:disabled {
            cursor: not-allowed;
          }
        }

        button {
          width: 60px;
          height: 32px;
          background: #fff;
          font-size: 12px;
          border-radius: 4px;
          position: absolute;
          right: 0;
          bottom: 0;
          border: 1px solid #303030;
          outline: none;
          cursor: pointer;

          &:disabled {
            cursor: not-allowed;
          }

          &.validation {
            width: 120px;
          }
        }

        &.validation_code {
          input {
            padding-left: 10px;
          }
        }
      }

      .drawer-footer {
        background: #000;
        // position: absolute;
        // bottom: 0;
        // right: 0;
        display: flex;
        justify-content: space-between;
        width: 100%;
        z-index: 100;
        // text-align: center;

        padding: 10px 0;

        button {
          background: none;
          box-shadow: 0px 5px 15px -3px rgba(0, 0, 0, 0.2);
          border: 1px solid #ffffff;
          color: #fff;
          font-size: 16px;
          width: 100px;
          height: 32px;
          border-radius: 4px;
          cursor: pointer;
          transition: 0.5s;

          &:hover {
            background: #fff;
            color: #000;
          }
        }
      }

      .email_c {
        position: relative;

        input {
          background: #303030;
          height: 32px;
          border-radius: 4px;
          padding-left: 10px;
          width: 100%;
          outline: none;
          border: none;

          &:disabled {
            cursor: not-allowed;
          }
        }

        button {
          width: 60px;
          height: 32px;
          background: #fff;
          font-size: 12px;
          border-radius: 4px;
          position: absolute;
          right: 0;
          bottom: 0;
          border: 1px solid #303030;
          outline: none;
          cursor: pointer;
        }
      }
    }
  }

  &.register_style {
    .ivu-drawer-content {
      height: 100vh;

      .ivu-drawer-header-inner {
        color: #fff;
        font-weight: bold;
      }
    }
  }
}

.van-tabbar {
  background-color: #1f1f1f;

  .van-tabbar-item {
    color: #cccccc;
  }

  .van-icon {
    color: #cccccc;
  }
}

.van-tabbar-item--active {
  color: orange !important;
  background-color: #1f1f1f;

  .van-icon {
    color: orange !important;
  }
}

#zmmtg-root {
  z-index: 1000;
  display: none;

  // .meeting-client-inner {
  //   padding-top: 70px;
  //   padding-bottom: 40px;
  // }

  #mic-btn {
    left: 5px;
  }

  .media-preview-avatar-signed-in {
    left: 2%;
  }

  // #wc-container-right{
  //   padding-top: 70px;
  //   padding-bottom: 100px;
  // }

  .dropdown-menu {
    // left: 114px;
    // background: #000;

    &.avatar-menu {
      left: 0px;
    }
  }
  #foot-bar {
    .dropdown-menu {
      background: #000;
      li a:hover,
      li a:focus {
        background: #fff;
      }
    }
  }
  .video-option-menu {
    .dropdown-menu {
      left: 50%;
    }
  }

  // .chat-container__chat-control{
  //   padding: 20px 10px;
  // }

  .main-layout {
    height: calc(100vh - 70px);
  }

  .chat-container__chat-control {
    padding: 10px;
    height: auto;

    .chat-receiver-list {
      .btn-group {
        .chat-receiver-list__receiver {
          background: #000 !important;
          line-height: 1;
          padding: 4px 12px;
        }
      }
    }
  }

  // .chat-container.window-content-bottom {
  //   height: calc(100vh - 70px - 40px);

  //   .chat-container__chat-list{
  //     height: calc(100vh - 70px - 40px - 154px);
  //   }
  // }
}

.drawer-footer-admin {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  z-index: 10;
}

.prism-player .prism-cc-btn {
  background-image: url("/static/images/cc.png");
  width: 28px;
  height: 28px;
  margin-top: 9px !important;

  &:hover {
    animation: none;
  }
}

.ivu-btn:hover {
  border-color: #e0e0e0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue